/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";
import CalendarIcon2 from "~misc/icons";
import useServico from "./useServico";
import { getFracionamentoDescarga } from "~services/GlobalServices";
import useVendedor from "~/fetchs/useVendedor";
import Dexie from "dexie";

const usePrecoCliente = ({
  filters,
  setLoading,
  onlyVigenciaVencendo,
  id,
  produtoFilialId,
  microrregiao,
  cluster,
  skip,
  take,
}) => {
  const { servicos } = useServico({ microrregiaoId: microrregiao });
  const { clientesSelecionados } = useVendedor();

  const onLoading = () => {
    if (typeof setLoading == "function") setLoading(true);
  };

  const offLoading = () => {
    if (typeof setLoading == "function") setLoading(false);
  };

  const [precos, setPrecos] = useState([]);
  const [precoCliente, setPrecoCliente] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalRenderizado, setTotalRenderizado] = useState(0);
  const [clientesDisponiveis, setClientesDisponiveis] = useState([]);

  const PrecoClienteQuery = async () => {
    let precosQuery = db.precosCliente;
    let filter = 0;
    onLoading();
    const clienteIds = new Set();
    await db.precosCliente.each((preco) => {
      clienteIds.add(preco.clienteId);
    });
    const uniqueClienteIds = Array.from(clienteIds);

    setClientesDisponiveis(Array.from(uniqueClienteIds));

    if (onlyVigenciaVencendo) {
      precosQuery = precosQuery.where("proximaVencimento").equals(1);
      filter = 1;
    }

    if (id > 0) {
      const clienteId = parseInt(id);
      precosQuery = precosQuery.where("clienteId").equals(clienteId);
      filter = 1;
    }

    if (
      filters?.grupoProduto ||
      filters?.produto ||
      filters?.filial ||
      filters?.unidadeMedida ||
      filters?.tipoSolicitacao ||
      filters?.cliente
    ) {
      precosQuery = precosQuery.filter(filterPrecoCliente);
      filter = 1;
    }

    if (clientesSelecionados) {
      precosQuery = precosQuery.filter((x) => clientesSelecionados.includes(x.clienteId));
      filter = 1;
    }

    if (!(id > 0)) {
      const thisTotal = await precosQuery.count();
      setTotal(thisTotal);
    }

    return { precosQuery, filter };
  };

  const filterPrecoCliente = (precoCliente) => {
    return (
      (filters?.grupoProduto
        ? (precoCliente.grupoProdutoId ?? precoCliente.grupoMaterialId) === filters?.grupoProduto
        : true) &&
      (filters?.produto ? precoCliente.produtoId === filters?.produto : true) &&
      (filters?.filial ? precoCliente.filialId === filters?.filial : true) &&
      (filters?.unidadeMedida ? precoCliente.unidadeMedidaId === filters?.unidadeMedida : true) &&
      (filters?.tipoSolicitacao ? precoCliente.tipoCondicaoId === filters?.tipoSolicitacao : true) &&
      (filters?.cliente ? precoCliente.clienteId === filters?.cliente : true)
    );
  };

  const getQuery = (key, filter, precosQuery, reverse = false) => {
    if (filter === 1) {
      return reverse
        ? precosQuery
            .offset(0)
            .limit(take + skip)
            .reverse()
            .sortBy(key)
        : precosQuery
            .offset(0)
            .limit(take + skip)
            .sortBy(key);
    }
    return reverse
      ? precosQuery
          .orderBy(key)
          .reverse()
          .offset(0)
          .limit(take + skip)
      : precosQuery
          .orderBy(key)
          .offset(0)
          .limit(take + skip);
  };

  useEffect(() => {
    const fetchPrecosCliente = async () => {
      let { precosQuery, filter } = await PrecoClienteQuery();

      // Aplica ordenação
      if (filters?.ordem) {
        switch (filters.ordem) {
          case "recentes":
            precosQuery = getQuery("vigenciaTimestamp", filter, precosQuery);
            break;
          case "antigos":
            precosQuery = getQuery("vigenciaTimestamp", filter, precosQuery, true);
            break;
          case "ordem-alfabetica":
            precosQuery = getQuery("clienteNome", filter, precosQuery);
            break;
          case "ordem-crescente":
            precosQuery = getQuery("faixaF", filter, precosQuery);
            break;
          case "ordem-decrescente":
            precosQuery = getQuery("faixaF", filter, precosQuery, true);
            break;
          default:
            precosQuery = precosQuery.offset(0).limit(take + skip);
            break;
        }
      } else {
        precosQuery = precosQuery.offset(0).limit(take + skip);
      }

      let result = [];
      if (precosQuery instanceof Dexie.Promise) {
        result = await precosQuery;
      } else if (typeof precosQuery.each === "function") {
        result = await precosQuery.toArray();
      } else {
        result = await precosQuery.toArray();
      }
      setPrecos(result);
      setTotalRenderizado(result.length);
      offLoading();
    };
    fetchPrecosCliente();
  }, [filters, skip, clientesSelecionados]);

  useEffect(() => {
    const fetchOrdenacao = async () => {
      if (id) {
        await db.ordenacaoTabelaPreco.filter((otp) => otp.clienteId == id).toArray();

        offLoading();
      }
    };
    fetchOrdenacao();
  }, [id]);

  useEffect(() => {
    const fetchPrecosCliente = async () => {
      const _id = typeof id === "number" ? id : Number(id);
      if (Number.isNaN(_id) || _id <= 0) {
        setPrecoCliente([]);
      } else {
        let precosQuery = db.precosCliente.where("clienteId").equals(_id);

        if (produtoFilialId > 0) {
          precosQuery = precosQuery.and((e) => e.produtoFilialId === produtoFilialId);
        }

        const precos = [];
        await precosQuery.each((precoCliente) => {
          precos.push(precoCliente);
        });

        setPrecoCliente(precos);
      }
    };
    fetchPrecosCliente();
  }, [id, produtoFilialId]);

  const PrecoRegraQuery = () => {
    let precosQuery = db.tabelaPreco;

    if (id > 0 && microrregiao && cluster) {
      precosQuery = precosQuery.filter(
        (e) => e.microrregiaoId == microrregiao && (e.clusterId == cluster || !e.clusterId)
      );
    } else if (id > 0 && microrregiao) {
      precosQuery = precosQuery.filter((e) => e.microrregiaoId == microrregiao);
    }

    precosQuery = precosQuery.filter(filterPrecoCliente);

    return precosQuery;
  };

  useEffect(() => {
    const fetchCountPrecosRegra = async (precosQuery) => {
      const { precosQuery: precosClienteQuery } = await PrecoClienteQuery();
      const totalCliente = await precosClienteQuery.count();
      const totalRegra = await precosQuery.count();
      setTotal(totalCliente + totalRegra);
    };

    const fetchPrecosRegra = async () => {
      let precosQuery = PrecoRegraQuery();

      if (id > 0) {
        fetchCountPrecosRegra(precosQuery);
      }

      await precosQuery
        .offset(0)
        .limit(skip + take)
        .toArray();

      offLoading();
    };
    if (id > 0 && (microrregiao || cluster)) {
      fetchPrecosRegra();
    }
  }, [id, microrregiao, cluster, skip, filters, clientesSelecionados]);

  const precosCliente = useMemo(() => {
    if (precos) {
      const thisPrecosMap = new Map();

      for (const obj of precos) {
        if (!thisPrecosMap.has(obj.clienteId)) {
          thisPrecosMap.set(obj.clienteId, {
            clienteId: obj.clienteId,
            labelHeader: obj.clienteLabel,
            vigencias: ArrumaVigencia(precos, obj.clienteId ?? id, servicos, obj.filialId),
            precos: [],
          });
        }
      }

      const thisPrecos = Array.from(thisPrecosMap.values());

      if (thisPrecos.length > 0) offLoading();

      return thisPrecos;
    }
  }, [precos, servicos]);

  const clientesOption = useMemo(() => {
    if (precos) {
      const acc = {};
      for (const cur of precos) {
        if (!acc[`id-${cur.clienteId}`]) {
          acc[`id-${cur.clienteId}`] = {
            value: cur.clienteId,
            label: cur.clienteLabel,
          };
        }
      }
      return Object.values(acc);
    }
    return [];
  }, [precos]);

  return {
    clientesOption,
    precosCliente: precosCliente,
    precoCliente,
    total,
    totalRenderizado,
    clientesDisponiveis,
  };
};

export default usePrecoCliente;

export const ArrumaVigencia = (precos, clienteId, servicos, filialId) => {
  const vigencias = [];

  for (const obj of precos || []) {
    if (obj.clienteId === clienteId && obj.filialId === filialId) {
      const existingVigencia = vigencias.find((v) => v.header.title === "Vigência: " + obj.vigenciaLabel);

      if (!existingVigencia) {
        vigencias.push({
          header: {
            icon: <CalendarIcon2 />,
            title: "Vigência: " + obj.vigenciaLabel,
            alert: obj.proximaVencimento === 1,
          },
          checkboxes: true,
          produtos: ArrumaProdutos(precos, clienteId, obj.vigenciaLabel, servicos),
        });
      }
    }
  }

  return vigencias;
};

export const ArrumaDestaque = (precos, servicos) => {
  return [
    {
      header: {
        title: "Produtos mais comprados",
      },
      checkboxes: false,
      produtos: ArrumaProdutosDestaque(precos, servicos),
    },
  ];
};

export const ArrumaOutros = (precos, servicos) => {
  return [
    {
      header: {
        title: "Produtos para oferecer",
      },
      checkboxes: false,
      produtos: ArrumaProdutosDestaque(precos, servicos),
    },
  ];
};

export const ArrumaProdutos = (precos, clienteId, vigenciaLabel, servicos) => {
  const produtos = [];

  for (const e of precos || []) {
    if (e.clienteId === clienteId && e.vigenciaLabel === vigenciaLabel) {
      const precosServicos = getFracionamentoDescarga(servicos, e);
      produtos.push({
        ...e,
        isChecked: false,
        precosServicos,
        color: {
          cif: e.tipoCondicaoId === 1 && (e.precoRegraCIF !== e.precoFinalCIF || e.precoEspecialCIF !== "0.00"),
          fob: e.tipoCondicaoId === 1 && (e.precoRegraFOB !== e.precoFinalFOB || e.precoEspecialFOB !== "0.00"),
          prazo: e.prazoCIF || e.prazoFOB,
        },
      });
    }
  }

  return produtos;
};

export const ArrumaProdutosDestaque = (precos, servicos) => {
  const produtos = [];

  for (const e of precos || []) {
    const precosServicos = getFracionamentoDescarga(servicos, e);
    produtos.push({
      ...e,
      isChecked: false,
      precosServicos,
      color: {
        cif: e.tipoCondicaoId === 1 && (e.precoRegraCIF !== e.precoFinalCIF || e.precoEspecialCIF !== "0.00"),
        fob: e.tipoCondicaoId === 1 && (e.precoRegraFOB !== e.precoFinalFOB || e.precoEspecialFOB !== "0.00"),
        prazo: e.prazoCIF || e.prazoFOB,
      },
    });
  }

  return produtos;
};

export const ArrumaDesconto = (descontoStr) => {
  if (!descontoStr) return 0;

  if (descontoStr.indexOf("-") > -1) return parseFloat(`-${descontoStr.replaceAll("-", "")}`);

  return parseFloat(descontoStr);
};
